import { Form } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { getCodigo, postRegister, validarCoberturaUser } from "../../services/serviceVivetuseguro";

const SidebarActivarCuentaDocumento = ({
  errorData,
  setErrorData,
  mensaje,
  setMensaje,
  recaptchaRef,
  setSpinner,
  form,
  setForm,
  setFormCode,
  formCode,
  setCount,
  urlApi,
  codRecaptcha,
  close,
  setShowLogin,
}) => {
  const handleChange = (e) => {
    document.getElementById(e.target.id).style.borderColor =
      "var(--bs-border-color)";
    document.getElementById(e.target.id).style.color =
      "var(--bs-offcanvas-color)";
    setMensaje("");
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const gotoLogin = () => {
    close();
    setShowLogin(true);
  };

  const handleSubmitDocumento = async (e) => {
    if (form.identificacion.trim() === "") {
      document.getElementById("identificacion").style.borderColor =
        "var(--rojo)";
      setMensaje("Este campo es obligatorio");
      setErrorData(true);
      console.log(form.identificacion)
      return;
    }

    const pattern = /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/;
    if (!form.identificacion.trim().match(pattern)) {
      document.getElementById("identificacion").style.borderColor =
        "var(--rojo)";
      document.getElementById("identificacion").style.color = "var(--rojo)";
      setMensaje("Revisa que contenga @ y los puntos necesarios.");
      setErrorData(true);
      return;
    }

    const token = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();
    if (!token) {
      setMensaje("Captcha inválido, actualizar web");
      return;
    }

    setSpinner(true);
    setMensaje("");

    let datos = {
      identificacion: "",
      email: form.identificacion,
      celular: formCode.fono,
      tipoIdentificacion: 5,
      cobertura: "Empleabilidad",
      tokenCaptcha: token,
    };

    try {
      const rpta = await postRegister(datos, urlApi);
      const rptaValidaCobertura = await validarCoberturaUser(datos, urlApi);

      if (rpta.Codigo === 1 || rpta.Codigo === 10) {
        setMensaje(rpta.Mensaje);
        setErrorData(true);
        setSpinner(false);
        document.getElementById("identificacion").style.borderColor =
          "var(--rojo)";
        document.getElementById("identificacion").style.color = "var(--rojo)";
      } else if (rpta.Codigo === 2) {
        // setMensaje(rpta.Mensaje);
        setMensaje(
          "Encontramos una cuenta activa para este correo.\nPor favor, inicia sesión"
        );
        setErrorData(true);
        setSpinner(false);
        document.getElementById("identificacion").style.borderColor =
          "var(--rojo)";
        document.getElementById("identificacion").style.color = "var(--rojo)";
      } else if (rpta.Codigo === 3) {
        // setMensaje(rpta.Mensaje);
        setMensaje("Producto contratado inactivo");
        setErrorData(true);
        setSpinner(false);
        document.getElementById("identificacion").style.borderColor =
          "var(--rojo)";
        document.getElementById("identificacion").style.color = "var(--rojo)";
      } else if (rpta.Codigo === 4) {
        setMensaje(
          "Información ingresada no corresponde a la registrada. Inténtelo de nuevo."
        );
        setErrorData(true);
        setSpinner(false);
        document.getElementById("identificacion").style.borderColor =
          "var(--rojo)";
        document.getElementById("identificacion").style.color = "var(--rojo)";
      } else if (rpta.Codigo === 0) {
        // CONFORME
        setMensaje("");

        if (!rptaValidaCobertura) {
          document.getElementById("identificacion").style.borderColor = "var(--rojo)";
          document.getElementById("identificacion").style.color = "var(--rojo)";
          setMensaje("Aún no cuentas con tu Seguro de Empleabilidad")
          setErrorData(true);
          setSpinner(false)
          return;
        }

        let objUsuario = {
          identificacion: form.identificacion,
          tokenCaptcha: token,
        };

        getCodigo(objUsuario, urlApi).then((res) => {
          // console.log({ res })
          setSpinner(false);
          if (res.codigo === 0) {
            setMensaje("");
            setErrorData(false);
            setFormCode({
              ...formCode,
              id: res.data,
              fono: rpta.user.fono,
              tokenCaptcha: token,
            });

            setCount(2);
            return;
          } else if (res.codigo === 1) {
            setErrorData(true);
            if (res.mensaje === "No se validó el captcha") {
              setMensaje(res.mensaje);
            } else {
              setMensaje(
                "Utiliza el correo que registraste al adquirir tu seguro"
              );
            }
          } else {
            setMensaje(res.mensaje);
          }
          setErrorData(true);
          document.getElementById("identificacion").style.borderColor =
            "var(--rojo)";
          document.getElementById("identificacion").style.color = "var(--rojo)";
        });
      }
    } catch (err) {
      document.getElementById("identificacion").style.borderColor =
        "var(--rojo)";
      document.getElementById("identificacion").style.color = "var(--rojo)";
      setSpinner(false);
      setMensaje("Error en el registro");
    }
  };

  return (
    <>
      <div className="body__login">
        <h2>Activa tu cuenta</h2>
        <p>
          Ingresa los mismos datos que registraste al adquirir tu seguro
          Scotiabank
        </p>
        <Form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className="form__modal"
        >
          <div className="row justify-content-center">
            <div className="col-12">
              <label className="label__text">
                <b>Correo electrónico</b>
              </label>
              <input
                type="text"
                className="form-control border-input "
                id="identificacion"
                name="identificacion"
                placeholder="Ingresa tu correo"
                autoComplete="off"
                value={form.identificacion}
                onChange={handleChange}
              />
            </div>
            {errorData && (
              <div className="texto__error__campo">
                <p>{mensaje}</p>
              </div>
            )}
            <div style={{ textAlign: "center" }} className="col-12 mb-4">
              <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={codRecaptcha}
              />
              <button className="btn__azul" onClick={handleSubmitDocumento}>
                CONTINUAR
              </button>
            </div>
          </div>
        </Form>
        <p>
          ¿Ya tienes una cuenta?{" "}
          <span
            onClick={gotoLogin}
            style={{ color: "var(--rojo)", cursor: "pointer" }}
          >
            Inicia sesión
          </span>
        </p>
      </div>
    </>
  );
};

export default SidebarActivarCuentaDocumento;
